/**
 * Torso outfit textures: vietnamese
 */
import { drawLotusFlower, drawLotusLeaf, drawStem } from '../motifs.js';

export function drawTorso_ao_dai(ctx, size, _options = {}) {
  // 1. ÁO DÀI TRẮNG TRUYỀN THỐNG VIỆT NAM (Quốc phục nữ sinh / thiếu nữ Việt Nam)
  // Nền áo lụa trắng ngọc ngà
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, size, size);

  // Ánh lụa: vệt sáng dọc mềm trên nền trắng
  const sheen = ctx.createLinearGradient(0, 0, size, 0);
  sheen.addColorStop(0, 'rgba(226, 232, 240, 0.35)');
  sheen.addColorStop(0.45, 'rgba(255, 255, 255, 0)');
  sheen.addColorStop(1, 'rgba(226, 232, 240, 0.35)');
  ctx.fillStyle = sheen;
  ctx.fillRect(0, 0, size, size);

  // Cổ đứng (cổ lãnh) có viền
  ctx.fillStyle = '#f8fafc';
  ctx.fillRect(size * 0.36, 0, size * 0.28, size * 0.1);
  ctx.strokeStyle = 'rgba(148, 163, 184, 0.6)';
  ctx.lineWidth = size * 0.012;
  ctx.strokeRect(size * 0.36, 0, size * 0.28, size * 0.1);

  // Đường cắt ráp tay Raglan truyền thống (chạy chéo từ chân cổ xuống nách)
  ctx.strokeStyle = 'rgba(148, 163, 184, 0.4)';
  ctx.lineWidth = size * 0.018;
  ctx.beginPath();
  // Đường raglan vai trái
  ctx.moveTo(size * 0.34, size * 0.12);
  ctx.lineTo(size * 0.1, size * 0.4);
  // Đường raglan vai phải
  ctx.moveTo(size * 0.66, size * 0.12);
  ctx.lineTo(size * 0.9, size * 0.4);
  ctx.stroke();

  // Eo thon chiết ly tôn dáng thanh thoát
  ctx.strokeStyle = 'rgba(148, 163, 184, 0.35)';
  ctx.lineWidth = size * 0.012;
  ctx.beginPath();
  ctx.moveTo(size * 0.3, size * 0.42);
  ctx.quadraticCurveTo(size * 0.34, size * 0.62, size * 0.28, size * 0.88);
  ctx.moveTo(size * 0.7, size * 0.42);
  ctx.quadraticCurveTo(size * 0.66, size * 0.62, size * 0.72, size * 0.88);
  ctx.stroke();

  // Đường cài chéo tà trước: từ chân cổ vòng xuống nách phải người mặc (bên trái ảnh), có cúc bấm
  ctx.strokeStyle = 'rgba(100, 116, 139, 0.55)';
  ctx.lineWidth = size * 0.012;
  ctx.beginPath();
  ctx.moveTo(size * 0.38, size * 0.1);
  ctx.quadraticCurveTo(size * 0.3, size * 0.2, size * 0.06, size * 0.3);
  ctx.stroke();
  ctx.fillStyle = '#cbd5e1';
  [
    [0.33, 0.16],
    [0.22, 0.24],
    [0.12, 0.28]
  ].forEach(([bx, by]) => {
    ctx.beginPath();
    ctx.arc(size * bx, size * by, size * 0.012, 0, Math.PI * 2);
    ctx.fill();
  });

  // Cành sen: thân mọc từ gấu áo lên, 1 hoa nở, 1 nụ, 2 lá sen
  drawStem(ctx, [size * 0.8, size, size * 0.74, size * 0.72, size * 0.66, size * 0.5], size * 0.018);
  drawStem(ctx, [size * 0.84, size, size * 0.9, size * 0.8, size * 0.86, size * 0.62], size * 0.014);
  drawStem(ctx, [size * 0.72, size, size * 0.6, size * 0.92, size * 0.5, size * 0.84], size * 0.014);
  drawLotusLeaf(ctx, size * 0.5, size * 0.84, size * 0.14, 0.55);
  drawLotusFlower(ctx, size * 0.64, size * 0.52, size * 0.25, -0.12);
  drawLotusFlower(ctx, size * 0.87, size * 0.64, size * 0.13, 0.3);
  drawLotusLeaf(ctx, size * 0.92, size * 0.94, size * 0.08, 0.5);
}

export function drawTorso_ao_ba_ba(ctx, size, options = {}) {
  // 2. ÁO BÀ BA NAM BỘ
  // Cổ tròn xẻ giữa
  ctx.fillStyle = options.skinColor || '#fcd5b5';
  ctx.beginPath();
  ctx.arc(size * 0.5, 0, size * 0.22, 0, Math.PI);
  ctx.fill();

  // Nẹp áo xẻ giữa
  ctx.strokeStyle = 'rgba(0, 0, 0, 0.2)';
  ctx.lineWidth = size * 0.025;
  ctx.beginPath();
  ctx.moveTo(size * 0.5, size * 0.2);
  ctx.lineTo(size * 0.5, size);
  ctx.stroke();

  // Hàng cúc tròn chạy dọc thân
  ctx.fillStyle = '#ffffff';
  [0.28, 0.42, 0.56, 0.7, 0.84].forEach((yPos) => {
    ctx.beginPath();
    ctx.arc(size * 0.5, size * yPos, size * 0.022, 0, Math.PI * 2);
    ctx.fill();
  });

  // Hai túi vuông vạt dưới áo bà ba
  ctx.fillStyle = 'rgba(0, 0, 0, 0.12)';
  ctx.fillRect(size * 0.15, size * 0.68, size * 0.25, size * 0.25);
  ctx.fillRect(size * 0.6, size * 0.68, size * 0.25, size * 0.25);
}

export function drawTorso_hoc_sinh_vn(ctx, size, _options = {}) {
  // 3. ĐỒNG PHỤC HỌC SINH KHĂN QUÀNG ĐỎ VIỆT NAM
  // Áo sơ mi trắng
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, size, size);

  // Cổ áo bẻ
  ctx.strokeStyle = '#cbd5e1';
  ctx.lineWidth = size * 0.015;
  ctx.beginPath();
  ctx.moveTo(size * 0.32, 0);
  ctx.lineTo(size * 0.5, size * 0.18);
  ctx.lineTo(size * 0.68, 0);
  ctx.stroke();

  // Khăn quàng đỏ thắm thắt nơ trước ngực
  ctx.fillStyle = '#dc2626';
  // Nút thắt giữa
  ctx.beginPath();
  ctx.ellipse(size * 0.5, size * 0.2, size * 0.08, size * 0.05, 0, 0, Math.PI * 2);
  ctx.fill();
  // Hai vạt khăn quàng buông xuống
  ctx.beginPath();
  ctx.moveTo(size * 0.46, size * 0.22);
  ctx.lineTo(size * 0.35, size * 0.6);
  ctx.lineTo(size * 0.48, size * 0.55);
  ctx.closePath();
  ctx.fill();

  ctx.beginPath();
  ctx.moveTo(size * 0.54, size * 0.22);
  ctx.lineTo(size * 0.62, size * 0.65);
  ctx.lineTo(size * 0.5, size * 0.58);
  ctx.closePath();
  ctx.fill();

  // Phù hiệu trường ngực trái
  ctx.fillStyle = '#2563eb';
  ctx.fillRect(size * 0.18, size * 0.3, size * 0.15, size * 0.12);
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(size * 0.2, size * 0.32, size * 0.11, size * 0.08);
}

export function drawTorso_ao_ba_lo(ctx, size, options = {}) {
  // 8. ÁO BA LỖ THỂ THAO / DÂN DÃ (TANK TOP)
  // Thân áo phủ trọn vẹn màu áo (đỏ của Gymer, trắng của Bác Trà Đá)
  const skin = options.skinColor || '#fcd5b5';

  // Khoét nách hai bên vai uốn lượn cong tự nhiên
  ctx.fillStyle = skin;
  ctx.beginPath();
  ctx.moveTo(0, 0);
  ctx.lineTo(size * 0.16, 0);
  ctx.quadraticCurveTo(size * 0.1, size * 0.3, 0, size * 0.42);
  ctx.closePath();
  ctx.fill();

  ctx.beginPath();
  ctx.moveTo(size, 0);
  ctx.lineTo(size * 0.84, 0);
  ctx.quadraticCurveTo(size * 0.9, size * 0.3, size, size * 0.42);
  ctx.closePath();
  ctx.fill();

  // Viền may bo nách áo
  ctx.strokeStyle = 'rgba(0, 0, 0, 0.18)';
  ctx.lineWidth = size * 0.016;
  ctx.beginPath();
  ctx.moveTo(size * 0.16, 0);
  ctx.quadraticCurveTo(size * 0.1, size * 0.3, 0, size * 0.42);
  ctx.moveTo(size * 0.84, 0);
  ctx.quadraticCurveTo(size * 0.9, size * 0.3, size, size * 0.42);
  ctx.stroke();

  // Cổ áo khoét ovan vừa vặn (không bị khoét sâu dị dạng thành dải khăn)
  ctx.fillStyle = skin;
  ctx.beginPath();
  ctx.ellipse(size * 0.5, 0, size * 0.22, size * 0.13, 0, 0, Math.PI);
  ctx.fill();

  // Đường viền bo cổ áo ba lỗ (ribbed collar)
  ctx.strokeStyle = 'rgba(0, 0, 0, 0.22)';
  ctx.lineWidth = size * 0.02;
  ctx.beginPath();
  ctx.ellipse(size * 0.5, 0, size * 0.22, size * 0.13, 0, 0, Math.PI);
  ctx.stroke();
}

export function drawTorso_bao_ve(ctx, size, options = {}) {
  // 10. ĐỒNG PHỤC BẢO VỆ CHUNG CƯ / TÒA NHÀ CÔNG VỤ (Áo xanh da trời, cầu vai, 2 túi nắp gập)
  ctx.fillStyle = '#38bdf8'; // Xanh da trời đồng phục bảo vệ
  ctx.fillRect(0, 0, size, size);

  // Cổ áo bẻ sơ mi
  ctx.fillStyle = options.skinColor || '#fcd5b5';
  ctx.beginPath();
  ctx.moveTo(size * 0.4, 0);
  ctx.lineTo(size * 0.5, size * 0.16);
  ctx.lineTo(size * 0.6, 0);
  ctx.closePath();
  ctx.fill();

  // Cầu vai màu xanh tím than 2 bên vai
  ctx.fillStyle = '#0f172a';
  ctx.fillRect(0, 0, size * 0.22, size * 0.09);
  ctx.fillRect(size * 0.78, 0, size * 0.22, size * 0.09);

  // Cúc vàng cầu vai
  ctx.fillStyle = '#f59e0b';
  ctx.beginPath();
  ctx.arc(size * 0.16, size * 0.045, size * 0.02, 0, Math.PI * 2);
  ctx.arc(size * 0.84, size * 0.045, size * 0.02, 0, Math.PI * 2);
  ctx.fill();

  // 2 Túi ngực có nắp gập chữ nhật
  [-1, 1].forEach((side) => {
    const px = side === -1 ? size * 0.16 : size * 0.62;
    // Thân túi
    ctx.fillStyle = '#0284c7';
    ctx.fillRect(px, size * 0.32, size * 0.22, size * 0.24);
    // Nắp túi đậm màu
    ctx.fillStyle = '#0369a1';
    ctx.fillRect(px - size * 0.01, size * 0.28, size * 0.24, size * 0.06);
    // Cúc túi
    ctx.fillStyle = '#f59e0b';
    ctx.beginPath();
    ctx.arc(px + size * 0.11, size * 0.31, size * 0.015, 0, Math.PI * 2);
    ctx.fill();
  });

  // Bảng tên / Phù hiệu an ninh đỏ chữ vàng bên ngực trái
  ctx.fillStyle = '#dc2626';
  ctx.fillRect(size * 0.17, size * 0.22, size * 0.2, size * 0.045);
  ctx.fillStyle = '#fef08a';
  ctx.fillRect(size * 0.19, size * 0.235, size * 0.16, size * 0.015);

  // Nẹp cúc áo chạy dọc chính giữa
  ctx.fillStyle = '#0284c7';
  ctx.fillRect(size * 0.47, size * 0.16, size * 0.06, size * 0.84);
  for (let y = size * 0.25; y < size; y += size * 0.18) {
    ctx.fillStyle = '#0f172a';
    ctx.beginPath();
    ctx.arc(size * 0.5, y, size * 0.018, 0, Math.PI * 2);
    ctx.fill();
  }
}

export function drawTorso_so_mi_can_bo(ctx, size, options = {}) {
  // 11. ÁO SƠ MI CẮM THÙNG CÁN BỘ / TRƯỞNG BAN QUẢN TRỊ (Thắt lưng da bóng, nẹp cúc trang nghiêm)
  ctx.fillStyle = '#f1f5f9'; // Trắng ngà / xám sáng
  ctx.fillRect(0, 0, size, size);

  // Cổ áo sơ mi
  ctx.fillStyle = options.skinColor || '#fcd5b5';
  ctx.beginPath();
  ctx.moveTo(size * 0.42, 0);
  ctx.lineTo(size * 0.5, size * 0.15);
  ctx.lineTo(size * 0.58, 0);
  ctx.closePath();
  ctx.fill();

  // Nẹp cúc áo
  ctx.strokeStyle = '#cbd5e1';
  ctx.lineWidth = size * 0.015;
  ctx.beginPath();
  ctx.moveTo(size * 0.5, size * 0.15);
  ctx.lineTo(size * 0.5, size * 0.84);
  ctx.stroke();

  for (let y = size * 0.25; y < size * 0.8; y += size * 0.16) {
    ctx.fillStyle = '#64748b';
    ctx.beginPath();
    ctx.arc(size * 0.5, y, size * 0.015, 0, Math.PI * 2);
    ctx.fill();
  }

  // Túi áo ngực trái có bút bi cài
  ctx.strokeStyle = '#94a3b8';
  ctx.strokeRect(size * 0.65, size * 0.28, size * 0.2, size * 0.22);
  ctx.fillStyle = '#2563eb'; // Thân bút bi cài túi
  ctx.fillRect(size * 0.72, size * 0.24, size * 0.025, size * 0.1);
  ctx.fillStyle = '#f59e0b'; // Kẹp bút vàng
  ctx.fillRect(size * 0.74, size * 0.26, size * 0.01, size * 0.05);

  // Thắt lưng da nâu đen cắm thùng nghiêm chỉnh ở đáy áo
  ctx.fillStyle = '#451a03';
  ctx.fillRect(0, size * 0.85, size, size * 0.15);

  // Mặt khóa thắt lưng kim loại mạ vàng
  ctx.fillStyle = '#f59e0b';
  ctx.fillRect(size * 0.42, size * 0.87, size * 0.16, size * 0.11);
  ctx.fillStyle = '#78350f';
  ctx.fillRect(size * 0.45, size * 0.89, size * 0.1, size * 0.07);
}

export function drawTorso_genz_oversize(ctx, size, options = {}) {
  // 12. ÁO PHÔNG GEN Z OVERSIZE / HEALING
  ctx.fillStyle = '#1e1b4b'; // Tím than Indigo sành điệu
  ctx.fillRect(0, 0, size, size);

  // Bo viền cổ thun tròn
  ctx.fillStyle = options.skinColor || '#fcd5b5';
  ctx.beginPath();
  ctx.ellipse(size * 0.5, 0, size * 0.2, size * 0.1, 0, 0, Math.PI);
  ctx.fill();

  // Họa tiết Typo / Meme Voxel nghệ thuật trước ngực
  ctx.fillStyle = '#38bdf8';
  ctx.fillRect(size * 0.3, size * 0.32, size * 0.4, size * 0.05);
  ctx.fillStyle = '#f43f5e';
  ctx.fillRect(size * 0.35, size * 0.4, size * 0.3, size * 0.04);
  ctx.fillStyle = '#10b981';
  ctx.fillRect(size * 0.28, size * 0.48, size * 0.44, size * 0.035);
}

export function drawTorso_tien_loi(ctx, size, _options = {}) {
  // 13. POLO ĐỎ + TẠP DỀ YẾM CỬA HÀNG TIỆN LỢI
  ctx.fillStyle = '#dc2626';
  ctx.fillRect(0, 0, size, size);

  // Cổ áo polo trắng
  ctx.fillStyle = '#f8fafc';
  ctx.beginPath();
  ctx.moveTo(size * 0.36, 0);
  ctx.lineTo(size * 0.5, size * 0.14);
  ctx.lineTo(size * 0.64, 0);
  ctx.closePath();
  ctx.fill();

  // Dây đeo cổ tạp dề
  ctx.strokeStyle = '#18181b';
  ctx.lineWidth = size * 0.045;
  ctx.beginPath();
  ctx.moveTo(size * 0.33, size * 0.3);
  ctx.lineTo(size * 0.24, 0);
  ctx.moveTo(size * 0.67, size * 0.3);
  ctx.lineTo(size * 0.76, 0);
  ctx.stroke();

  // Yếm tạp dề: phần ngực hẹp, phần bụng rộng
  ctx.fillStyle = '#18181b';
  ctx.fillRect(size * 0.3, size * 0.28, size * 0.4, size * 0.3);
  ctx.fillRect(size * 0.12, size * 0.56, size * 0.76, size * 0.44);

  // Viền cam thương hiệu & bảng tên
  ctx.fillStyle = '#f59e0b';
  ctx.fillRect(size * 0.3, size * 0.28, size * 0.4, size * 0.03);
  ctx.fillStyle = '#f8fafc';
  ctx.fillRect(size * 0.36, size * 0.36, size * 0.16, size * 0.06);

  // Túi lớn trước bụng
  ctx.strokeStyle = '#52525b';
  ctx.lineWidth = size * 0.016;
  ctx.strokeRect(size * 0.22, size * 0.7, size * 0.56, size * 0.22);
  ctx.beginPath();
  ctx.moveTo(size * 0.5, size * 0.7);
  ctx.lineTo(size * 0.5, size * 0.92);
  ctx.stroke();
}

export function drawTorso_lab_coat(ctx, size, _options = {}) {
  // Áo blouse trắng
  ctx.fillStyle = '#f8fafc';
  ctx.fillRect(0, 0, size * 0.38, size);
  ctx.fillRect(size * 0.62, 0, size * 0.38, size);

  ctx.strokeStyle = '#cbd5e1';
  ctx.lineWidth = size * 0.02;
  ctx.beginPath();
  ctx.moveTo(size * 0.38, 0);
  ctx.lineTo(size * 0.38, size);
  ctx.moveTo(size * 0.62, 0);
  ctx.lineTo(size * 0.62, size);
  ctx.stroke();

  // Cà vạt bên trong
  ctx.fillStyle = '#2563eb';
  ctx.beginPath();
  ctx.moveTo(size * 0.5, size * 0.15);
  ctx.lineTo(size * 0.45, size * 0.4);
  ctx.lineTo(size * 0.5, size * 0.55);
  ctx.lineTo(size * 0.55, size * 0.4);
  ctx.closePath();
  ctx.fill();
}

export const vietnamese_drawers = {
  ao_dai: drawTorso_ao_dai,
  ao_ba_ba: drawTorso_ao_ba_ba,
  hoc_sinh_vn: drawTorso_hoc_sinh_vn,
  ao_ba_lo: drawTorso_ao_ba_lo,
  bao_ve: drawTorso_bao_ve,
  so_mi_can_bo: drawTorso_so_mi_can_bo,
  so_mi: drawTorso_so_mi_can_bo,
  genz_oversize: drawTorso_genz_oversize,
  tien_loi: drawTorso_tien_loi,
  lab_coat: drawTorso_lab_coat
};
